module.exports = __webpack_public_path__ + "static/img/75a6.a7a9843.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/75a6.jpg
// module id = 10MW
// module chunks = 1